export default {
  HomePage: {
    title: 'Estimator24 — Yapay Zeka ile Gayrimenkul Değerleme',
    description: 'Avrupa ve Türkiye’deki daireler, evler ve konut projeleri için yapay zeka destekli değerleme.'
  },
  AboutPage: {
    title: 'Estimator24 Hakkında',
    description: 'Gayrimenkul değerleme, analiz ve yatırım platformu.'
  },
  PropertyList: {
    title: 'Gayrimenkul Kataloğu — Estimator24',
    description: 'Tüm daireler, villalar ve evler AI değerlendirmesiyle. Ülke, bölge ve geliştiriciye göre arama yapın.'
  },
  PropertyDetail: {
    title: '{title} — {city} — Estimator24',
    description: '{city} şehrindeki gayrimenkul için ayrıntılı bilgi ve AI değerlemesi.'
  },
  DeveloperList: {
    title: 'Geliştiriciler — Estimator24',
    description: 'Gayrimenkul geliştiricileri ve inşaat şirketleri kataloğu.'
  },
  DeveloperDetail: {
    title: '{developer} — Geliştirici — Estimator24',
    description: '{developer} tarafından geliştirilen projeler ve konut kompleksleri.'
  },
  ResidentialComplexShow: {
    title: '{title} — Konut Kompleksi — Estimator24',
    description: '{title} projesi için açıklama, fiyatlar ve planlar.'
  },
  AgencyList: {
    title: 'Emlak Ajansları — Estimator24',
    description: 'Emlak ajanslarının ve ilanlarının listesi.'
  },
  AgencyDetail: {
    title: '{agency} — Emlak Ajansı — Estimator24',
    description: '{agency} ajansının ilanları ve iletişim bilgileri.'
  },
  NewsList: {
    title: 'Emlak Haberleri — Estimator24',
    description: 'Piyasa trendleri, analizler ve gayrimenkul istatistikleri.'
  },
  NewsDetail: {
    title: '{title} — Estimator24 Haberleri',
    description: '{excerpt}'
  },
  StatisticPage: {
    title: 'Gayrimenkul İstatistikleri — Estimator24',
    description: 'Fiyatlar, satışlar ve inşaat hacimleri hakkında gerçek zamanlı veriler.'
  },
  PrivacyPolicy: {
    title: 'Gizlilik Politikası — Estimator24',
    description: 'Kullanıcı verilerinin işlenme koşulları ve gizlilik politikası.'
  }
}
